export const blockIconsContentBolt = (
	<span className='material-symbols-outlined'>bolt</span>
);
